export const GSM_7_BASIC_CHARS =
  '@\u00A3$\u00A5\u00E8\u00E9\u00F9\u00EC\u00F2\u00C7\n\u00D8\u00F8\r\u00C5\u00E5\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039E\u00C6\u00E6\u00DF\u00C9 !"#\u00A4%&\'()*+,-./0123456789:;<=>?\u00A1ABCDEFGHIJKLMNOPQRSTUVWXYZ\u00C4\u00D6\u00D1\u00DC\u00A7\u00BFabcdefghijklmnopqrstuvwxyz\u00E4\u00F6\u00F1\u00FC\u00E0';
export const GSM_7_EXTENDED_CHARS = '^{}\\[~]|\u20AC';
export const AWS_SNS_MAX_SMS_LENGTH = 1600;

const GSM_7_BASIC_SET = new Set([...GSM_7_BASIC_CHARS]);
const GSM_7_EXTENDED_SET = new Set([...GSM_7_EXTENDED_CHARS]);

const GSM7_SINGLE_LIMIT = 160;
const GSM7_MULTI_LIMIT = 153;
const UNICODE_SINGLE_LIMIT = 70;
const UNICODE_MULTI_LIMIT = 67;

// Converts common typographic characters to their GSM-7 equivalents.
// Handles smart quotes/apostrophes (typed by mobile/Mac autocorrect), dashes, and ellipsis.
export const normalizeSmsText = (message) =>
  message
    .replace(/[\u2018\u2019]/g, "'")
    .replace(/[\u201C\u201D]/g, '"')
    .replace(/[\u2013\u2014]/g, '-')
    .replace(/\u2026/g, '...')
    .normalize('NFKC');

const isGsm7 = (text) =>
  [...text].every((char) => GSM_7_BASIC_SET.has(char) || GSM_7_EXTENDED_SET.has(char));

const getGsm7Units = (text) =>
  [...text].reduce((len, char) => len + (GSM_7_EXTENDED_SET.has(char) ? 2 : 1), 0);

export const getSmsDetails = (message) => {
  const text = normalizeSmsText(`${message ?? ''}`);

  if (text.length > AWS_SNS_MAX_SMS_LENGTH) {
    return { isOverLimit: true, error: 'Message exceeds AWS SNS 1600 character limit' };
  }

  if (isGsm7(text)) {
    const length = getGsm7Units(text);
    const perSegmentLimit = length > GSM7_SINGLE_LIMIT ? GSM7_MULTI_LIMIT : GSM7_SINGLE_LIMIT;
    const segments = length <= GSM7_SINGLE_LIMIT ? 1 : Math.ceil(length / GSM7_MULTI_LIMIT);
    return { encoding: 'GSM-7', length, segments, perSegmentLimit, isOverLimit: false };
  }

  const { length } = text;
  const perSegmentLimit =
    length > UNICODE_SINGLE_LIMIT ? UNICODE_MULTI_LIMIT : UNICODE_SINGLE_LIMIT;
  const segments = length <= UNICODE_SINGLE_LIMIT ? 1 : Math.ceil(length / UNICODE_MULTI_LIMIT);
  return { encoding: 'Unicode', length, segments, perSegmentLimit, isOverLimit: false };
};
